// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"ba2518f4","256":"e8ccfce1","366":"6aca690f","886":"b230fc4d"}[chunkId] + ".css";
};